module.exports = __webpack_public_path__ + "img/fire-grey.1883c63f.svg";